import { Homepage, Login, History, GeoData, Reports, AdminUsers, GeometraSquadra, ChangePassword, RealtimeMap, ModificaLavoro, ModificaSegnalazione } from "@/pages";

const routes = [
  { path: '/home', name: 'home', component: Homepage },
  { path: '/', name: 'login', component: Login },
  {
      path: '/history/:scope',
      name: 'history',
      component: History
    },
  { path: '/geo-data', name: 'geo-data', component: GeoData },
  { path: '/reports', name: 'reports', component: Reports },
  { path: '/admin/users', name: 'admin-users', component: AdminUsers },
  { path: '/admin/geometra-squadra', name: 'geometra-squadra', component: GeometraSquadra },
  { path: '/profilo/cambia-password', name: 'change-password', component: ChangePassword },
  { path: '/mappa', name: 'realtime-map', component: RealtimeMap },
  { path: '/history/lavori/:uuid/modifica', name: 'modifica-lavoro', component: ModificaLavoro },
  { path: '/history/segnalazioni/:uuid/modifica', name: 'modifica-segnalazione', component: ModificaSegnalazione },
]

export default routes;